import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { logoutUser } from '../store/slices/authSlice';

/**
 * Custom hook for authentication state management using Redux
 * @returns {Object} Authentication state and methods
 */
const useAuth = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, user, loading, isInitialized } = useAppSelector((state) => state.auth);

  const logout = useCallback(async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      return { success: true };
    } catch (error) {
      console.error('Logout error:', error);
      return { success: false, error };
    }
  }, [dispatch]);

  // For backward compatibility
  const login = useCallback(() => {
    // console.warn('login method is deprecated, use Redux loginUser action instead');
  }, []);

  return {
    isLoggedIn: isAuthenticated,
    userRole: user?.user_type || null,
    user,
    loading,
    isInitialized,
    login,
    logout
  };
};

export default useAuth;